import React, { useMemo } from 'react';
import FooterItem, { IFooterItem } from './FooterItem';
import { useTranslation } from 'react-i18next';
import { NotificationIcon, LocationIcon, MapIcon, HealthIcon, SettingsIcon } from '../../icon/FooterIcons';

type IProps = {
    className?: string;
};

const Footer: React.FC<IProps> = ({ className }) => {
    const { t } = useTranslation();
    const navItems = useMemo(() => {
        const items: IFooterItem[] = [
            { 
                id: 'notification', 
                label: t('footer.menu.list'), 
                href: '/notification', 
                icon: <NotificationIcon className="transition-all duration-300" size={20} />
            },
            { 
                id: 'dashboard', 
                label: t('footer.menu.location'), 
                href: '/dashboard', 
                icon: <LocationIcon className="transition-all duration-300" size={20} />
            },
            { 
                id: 'location-history', 
                label: t('footer.menu.gps'), 
                href: '/location-history', 
                icon: <MapIcon className="transition-all duration-300" size={20} />
            },
            { 
                id: 'mental-health', 
                label: t('footer.menu.health'), 
                href: '/mental-health', 
                icon: <HealthIcon className="transition-all duration-300" size={20} />
            },
            { 
                id: 'settings', 
                label: t('footer.menu.settings'), 
                href: '/account', 
                icon: <SettingsIcon className="transition-all duration-300" size={20} />
            },
        ];
        return items;
    }, [t]);

    return (
        <footer
            className={`
                fixed bottom-6 left-1/2 transform -translate-x-1/2 
                w-[90%] max-w-sm h-16
                bg-gradient-to-r from-white/90 via-white/95 to-white/90
                backdrop-blur-xl backdrop-saturate-150
                border border-white/20
                shadow-2xl shadow-black/10
                rounded-2xl
                flex justify-around items-center
                transition-all duration-300 ease-in-out
                hover:shadow-3xl hover:shadow-black/15
                hover:scale-105
                z-50
                ${className}
            `}
            style={{
                background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.9) 50%, rgba(255,255,255,0.95) 100%)',
                backdropFilter: 'blur(20px) saturate(180%)',
                WebkitBackdropFilter: 'blur(20px) saturate(180%)',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1), 0 4px 16px rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.8)'
            }}
        >
            {navItems.map((item) => (
                <FooterItem key={item.id} {...item} />
            ))}
        </footer>
    );
};

export default Footer;
